import {
  TopMostExpensiveGroup,
  TopMostExpensiveGroupDatapoint,
} from '@cast/split-me/types';

import { useCrossAzCommunicationData } from './useCrossAzCommunicationData';

export type UseCrossAzCommunicationTrafficDataResult = {
  topItems: TopMostExpensiveGroup[];
  datapoints: TopMostExpensiveGroupDatapoint;
  isLoading: boolean;
  isFetching: boolean;
  error?: Error;
  refetch: () => void;
};

export const useCrossAzCommunicationTrafficData =
  (): UseCrossAzCommunicationTrafficDataResult => {
    const { topItems, datapoints, isLoading, isFetching, error, refetch } =
      useCrossAzCommunicationData('interZoneBytes');

    return {
      topItems,
      datapoints,
      isLoading,
      isFetching,
      error: error as Error | undefined,
      refetch,
    };
  };
